export const useCustomLink = function () {
  const runtimeConfig = useRuntimeConfig()
  const BASE_URL = runtimeConfig.app.baseURL
  const { $isWebViewFlag: isWebViewFlag } = useNuxtApp()

  function getNuxtLink(URI) {
    if (isWebViewFlag) {
      return URI
    } else {
      const NEW_URI = URI.replace(BASE_URL, '/')
      return NEW_URI
    }
  }

  // eslint-disable-next-line no-unused-vars
  function isExternal(URI) {
    return !!isWebViewFlag
  }

  return {
    getNuxtLink,
    isExternal
  }
}
